<template>
  <div class="city-operation">
    <HeaderTop title="金风科技在秦皇岛大事记"></HeaderTop>
    <div class="time-line-container">
      <div class="time-line-scroll">
        <div class="time-line" :style="{ width: calWidth() }">
          <div v-for="year in Object.keys(categorizedEvents)" :key="year" class="time-line-item">
            <div class="year">{{ year }}</div>
            <div class="month-container" v-for="month in Object.keys(categorizedEvents[year])" :key="month">
              <div class="month">{{ month }}</div>
              <div class="content">
                <div class="event-container"
                     v-for="(event, eventIndex) in categorizedEvents[year][month]" :key="event['标题']"
                     :style="{ top: $px2rem('-' + (eventIndex + 1) * 140 + 'px') }"
                     @click.stop="openDialog(event)">
                  <img :src="event['图片'][0]" alt="" />
                  <img :src="`/resource/events/${getPicByType(event['类型'])}_${event['picNo']}.png`"
                  :class="'size-' + event['picNo']"
                  :style="{
                    width: $px2rem(picSize[event['picNo'] - 1] + 'px'),
                    height: $px2rem(picSize[event['picNo'] - 1] + 'px'),
                  }"/>
<!--                  <img :src="getPicByType(event['类型'])" />-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialog.isShow" :modal-append-to-body="false">
      <div class="panel cur-timeline">
        <div class="header">
          <img src="../assets/img/icon-header.png">
        <span>{{ curTimeline['类型'] }}</span></div>
        <div class="body">
          <div class="info">{{ curTimeline['简介'] }}</div>
          <img v-if="curTimeline['图片']" :src="curTimeline['图片'][0]" alt="">
          <!--          <div class="top">-->
          <!--            <h2 class="title">{{ curTimeline['标题'] }}</h2>-->
          <!--            <p class="right">{{ curTimeline['时间'] }}</p>-->
          <!--          </div>-->
        </div>
      </div>
    </el-dialog>
    <el-button class="go-back" type="text" @click.stop="goBack">
      <i class="el-icon-back"></i>返回
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'events', // 城市运营
  data() {
    return {
      categorizedEvents: {},
      qinhuangdao: this.$store.state.page.pageConfig['金风科技在秦皇岛'],
      typeList: [
        { name: '领导莅临', pic: 'red' },
        { name: '政企合作', pic: 'pink' },
        { name: '产业带动', pic: 'grey' },
        { name: '人才培养', pic: 'green' },
        { name: '绿色赛事', pic: 'yellow' },
        { name: '项目建设', pic: 'orange' },
        { name: '产业带动', pic: 'blue' },
        { name: '教育科普', pic: 'blue' }
      ],
      picSize: [98, 117, 137, 138, 138, 138, 98],
      dialog: { // 时间线
        isShow: false,
        title: ''
      },
      curTimeline: {},
    }
  },
  computed: {
  },
  components: {
    HeaderTop: () => import('@/components/HeaderTop')
  },
  mounted() {
    this.initEvents()
  },
  methods: {
    openDialog (item) {
      this.curTimeline = item
      this.dialog.isShow = true
    },
    calWidth () {
      const px =  Object.values(this.categorizedEvents).reduce((acc, cur) => {
        return acc + Object.keys(cur).length * 140
      }, 0) + 140 + 50 + 'px'
      console.log(this.$px2rem(px))
      return this.$px2rem(px)
    },
    initEvents () {
      const categorizedEvents = {};
      this.qinhuangdao['大事记'].forEach(event => {
        event.picNo = this.getRandomInteger(1, 7)
        const [year, monthDay] = event.时间.split('年');
        const [month] = monthDay.split('月'); // 这里我们分割出了月份和日期，但day在后续没有使用
        if (!categorizedEvents[year]) {
          categorizedEvents[year] = {}
        }
        if (!categorizedEvents[year][month]) {
          categorizedEvents[year][month] = []
        }
        categorizedEvents[year][month].push(event)
      });
      this.categorizedEvents = categorizedEvents;
    },
    getPicByType(typeName) {
      const pic = this.typeList.find(item => item.name === typeName).pic
      // const randomInteger = this.getRandomInteger(1, 7)
      // return `/resource/events/${pic}_${randomInteger}.png`
      return pic
    },
    getRandomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    goBack () {
      this.$emit('prev')
    },
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";
.city-operation {
  width: 100vw;
  height: 100vh;
  background: url("/resource/img/city-operation.png") no-repeat center / cover;
  -webkit-overflow-scrolling: touch;
  &::after {
    display: block;
    content: "";
    clear: both;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    //width: 1920px;
    height: 242px;
    background: linear-gradient( 270deg, rgba(0,170,255,0.3) 0%, rgba(0,60,255,0.5) 52%, rgba(0,170,255,0.3) 100%);
    border: 1px solid #03A2F1;
    border-left: none;
    border-right: none;
    z-index: 0
  }
  .time-line-container {
    width: 100vw;
    height: calc(100vh - 100px);
    //border: 1px solid #03A2F1;
    position: absolute;
    bottom: 10px;
    z-index: 1;
    //overflow: hidden;
    .time-line-scroll {
      width: calc(100vw + 20px);
      height: 100vh;
      padding-left: 50px;
      overflow-x: scroll;
      overflow-y: hidden;
      -webkit-overflow-scrolling:touch;
      .time-line {
        position: relative;
        width: 999999999px;
        white-space: nowrap;
        padding-top: calc(100vh - 300px);
        box-sizing: border-box;

        &::after{
          content: "";
          display: block;
          clear: both;
          position: fixed;
          bottom: 90px;
          left: 50px;
          right: 0;
          width: 100%;
          height: 1px;
          background: #01B1FD;
        }

        .time-line-item {
          &:first-child {
            //margin-left: -50px;
          }
          position: relative;
          display: inline-block;
          color: #fff;
          .year {
            width: 140px;
            height: 20px;
            font-weight: bold;
            font-size: 40px;
            color: #FFFFFF;
            line-height: 20px;
            font-style: normal;
            text-align: center;
          }
          .month-container {
            display: inline-block;
            width: 140px;
            padding-top: 20px;
            position: relative;
            .month {
              height: 20px;
              font-size: 26px;
              color: #FFFFFF;
              line-height: 20px;
              font-style: normal;
              text-align: center;
              &:before {
                content: "";
                display: block;
                position: absolute;
                top: 60px;
                left: 25%;
                width: 1px;
                height: 10px;
                background: #01B1FD;
              }
              &:after {
                content: "";
                display: block;
                position: absolute;
                top: 60px;
                right: 25%;
                width: 1px;
                height: 10px;
                background: #01B1FD;
              }
            }
            .content {
              position: absolute;
              top: -100%;
              left: 0;
              .event-container {
                position: absolute;
                width: 126px;
                height: 126px;
                left: 0;
                top: -140px;
                cursor: pointer;
                box-sizing: border-box;
                text-align: center;
                padding: 21px;
                img{
                  width: 84px;
                  height: 84px;
                  object-fit: cover;
                  border-radius: 50%;
                  + img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    //transform-origin: top left;
                    z-index: 0;
                  }
                }
              }
            }
          }
        }

      }
    }
  }


  .panel.cur-timeline{
    background: rgba(0,61,114,0.59);
    padding: 40px 26px 26px;
    border: 1px solid;
    border-image: linear-gradient(135deg, rgba(0, 101, 255, 0), rgba(72, 150, 255, 1), rgba(0, 48, 255, 0)) 1 1;
    border-radius: 10px;
    backdrop-filter: blur(4px);
    .header{
      position: relative;
      height: 21px;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 21px;
      text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
      text-align: left;
      font-style: normal;
      margin-bottom: 10px;
      img {
        position: absolute;
        left: -20px;
        top: 0;
        width: 18px;
        vertical-align: middle;
        margin-right: 5px;
      }
      span{
        vertical-align: middle;
      }
    }
    .body{
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      font-family: PingFangSC, PingFang SC;
      line-height: 2;
      text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
      text-align: justify;
      font-style: normal;
      img {
        margin-top: 16px;
        width: 100%;
        max-height: 50vh;
        object-fit: cover;
      }
    }
  }
}

</style>
